import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { autocompleteClasses, Popper, styled, Autocomplete, ClickAwayListener, ListItemButton, TextField, } from "@mui/material";
const StyledAutocompletePopper = styled("div")(({ theme }) => ({
    [`& .${autocompleteClasses.paper}`]: {
        boxShadow: "none",
        margin: 0,
        color: "inherit",
        fontSize: 13,
    },
    [`& .${autocompleteClasses.listbox}`]: {
        padding: 0,
        [`& .${autocompleteClasses.option}`]: {
            minHeight: "auto",
            alignItems: "flex-start",
            padding: 8,
            borderBottom: `1px solid  ${theme.palette.mode === "light" ? " #eaecef" : "#30363d"}`,
        },
    },
    [`&.${autocompleteClasses.popperDisablePortal}`]: {
        position: "relative",
    },
}));
const StyledPopper = styled(Popper)(({ theme }) => ({
    border: `1px solid ${theme.palette.mode === "light" ? "#e1e4e8" : "#30363d"}`,
    boxShadow: `0 8px 24px ${theme.palette.mode === "light" ? "rgba(149, 157, 165, 0.2)" : "rgb(1, 4, 9)"}`,
    borderRadius: 6,
    width: 300,
    zIndex: theme.zIndex.modal,
    fontSize: 13,
    backgroundColor: "inherit",
}));
/**
 *
 * @param {Record<string, unknown>} props Component props
 * @returns {ReactElement} PopperComponent
 */
function PopperComponent(props) {
    return _jsx(StyledAutocompletePopper, { ...props });
}
/**
 * This component should not be used externally. It aims to reduce the NerdPhoneField.tsx file length.
 *
 * @param {StyledAutocompleteProps} props Component props
 * @returns {ReactElement} StyledAutocomplete
 */
export default function StyledAutocomplete(props) {
    const { anchorEl, handleClose, open, options, value, onChange } = props;
    return (_jsx(StyledPopper, { open: open, anchorEl: anchorEl, placement: "bottom-start", children: _jsx(ClickAwayListener, { onClickAway: handleClose, children: _jsx(Autocomplete, { PopperComponent: PopperComponent, disableClearable: true, open: true, value: value, onChange: onChange, options: options, getOptionLabel: (option) => `${option.fullName} (${option.countryCode}) +${option.callingCode}`, isOptionEqualToValue: (option, value) => option.countryCode == value.countryCode, renderOption: (props, option) => (_createElement(ListItemButton, { selected: value?.countryCode == option.countryCode ? true : false, component: "li", sx: {
                        "& > img": { mr: 2, flexShrink: 0 },
                    }, ...props, key: option.countryCode + option.callingCode }, `${option.flag} ${option.fullName} (${option.countryCode}) +${option.callingCode}`)), renderInput: (params) => (_jsx(TextField, { fullWidth: true, sx: {
                        padding: 1,
                    }, size: "small", ref: params.InputProps.ref, inputProps: params.inputProps, autoFocus: true })) }) }) }));
}
